import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import Aura from '@primeng/themes/aura';
import { AppComponent, AppModule } from 'app/app.module';
import { environment } from 'environments/environment';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { providePrimeNG } from 'primeng/config';

bootstrapApplication(
  AppComponent,
  {
    providers: [
      importProvidersFrom(AppModule),
      importProvidersFrom(BrowserAnimationsModule),
      importProvidersFrom(BrowserModule),
      provideAnimationsAsync(),
      provideCharts(withDefaultRegisterables()),
      provideHttpClient(withInterceptorsFromDi()),
      providePrimeNG({
        theme: {
          preset: Aura,
          options: {
            cssLayer: {
              name: 'primeng',
              order: 'tailwind-base, primeng, tailwind-utilities',
            },
          },
        },
      }),
      provideStore({}),
      // provideStoreDevtools({
      //   logOnly: environment.production,
      //   maxAge: 100,
      // }),
    ],
  },
)
  .catch(err => console.error(err));
